import { useState, useEffect } from "react";
import "./trialBtn.css";
import { Link } from "react-router-dom";

function TrialBtn() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show button after 1 second for smooth appearance
    const timer = setTimeout(() => {
      setVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    visible && (
      <div className="popup">
        {/* <a
          href="http://localhost:6009/request-signup"
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          Book a free trial 🚀
        </a> */}
        <Link className="link" to={"/request-signup"}>
          Book a free trial 🚀
        </Link>
      </div>
    )
  );
}

export default TrialBtn;
